export default __webpack_public_path__ + "static/media/lordguau-veterinaria.c8c75f28.jpg";